import { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/logo.svg";

const Nav = () => {
  const [toggle, setToggle] = useState(false);
  const navRef = useRef(null);

  const handleToggle = () => {
    setToggle((prev) => !prev);
  };

  const handleLinkClick = () => {
    setToggle(false);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setToggle(false);
      }
    };

    if (toggle) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggle]);

  return (
    <nav id="nav" ref={navRef}>
      <div className={`container ${toggle ? "nav-open" : ""}`}>
        <NavLink to="/">
          <img src={logo} alt="Logo" />
        </NavLink>
        <div className="menu">
          <ul className="nav-links">
            <li>
              <NavLink to="/skill-assessment" onClick={handleLinkClick}>Skill Assessment</NavLink>
            </li>
            {/* <li>
              <NavLink to="/career-guidance" onClick={handleLinkClick}>Career Guidance</NavLink>
            </li> */}
            <li>
              <NavLink to="/study-abroad" onClick={handleLinkClick}>Study Abroad</NavLink>
            </li>
            <li>
              <NavLink to="/about" onClick={handleLinkClick}>About Us</NavLink>
            </li>
              <li>
              <NavLink to="/testimonials" onClick={handleLinkClick}>Testimonials</NavLink>
            </li>
          </ul>
          <NavLink to="/contact" className="button yellow-button" onClick={handleLinkClick}>
            Contact
          </NavLink>
          <div className="toggle" onClick={handleToggle}>
            <span></span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
